import React, { ReactNode } from "react";
import Box from "@mui/material/Box";
import { classNames } from "repoV2/utils/common/render/classNames";
import styles from "./ModalStyles.module.scss";

interface ModalContentProps {
    children: ReactNode;
    className?: string;
}

const ModalContent = ({ children, className }: ModalContentProps) => (
    <Box className={classNames(styles.modalContent, className)}>{children}</Box>
);

ModalContent.defaultProps = {
    className: "",
};

export default ModalContent;
